/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { PaycardStatusDto } from './paycardStatusDto.schema';

export const IReadOnlyListOfPaycardStatusDto = zod.array(zod.lazy(() => PaycardStatusDto));

export type IReadOnlyListOfPaycardStatusDto = zod.input<typeof IReadOnlyListOfPaycardStatusDto>;
export type IReadOnlyListOfPaycardStatusDtoOutput = zod.output<typeof IReadOnlyListOfPaycardStatusDto>;
